import { render, staticRenderFns } from "./Renk.vue?vue&type=template&id=4e4a3d02&"
import script from "./Renk.vue?vue&type=script&lang=js&"
export * from "./Renk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports